export default __webpack_public_path__ + "static/media/praharsha.d4da32b5.png";